import React from "react";
import {
  Container,
  Nav,
  Navbar,
  Offcanvas,
  Button,
} from "react-bootstrap";
import "../Styles/NewHeader.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "../config/config";
import Cookies from "js-cookie";

const NewHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
        Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
      );

  const redirection = () => {
    navigate(`${config.baseUrl}dashboard`);
  };
  return (
    <>
      <Container className="px-0">
        {["xl"].map((expand) => (
          <Navbar key={expand} expand={expand} className=" mb-3 new-nav">
            <Container fluid>
              <Navbar.Brand href="#">
                {" "}
               <Link  to={`${config.baseUrl}`}> <img src="assets/images/newdesign/newlogo.svg" alt="" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle
                aria-controls={`offcanvasNavbar-expand-${expand}`}
              />
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img src="assets/images/newdesign/newlogo.svg" alt="" />
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="">
                  <Nav className="justify-content-center  flex-grow-1 gap-2 pe-3 mb-lg-0 mb-3">
                    <Link
                      className={`scrl nav-link new-nav-link ${
                        pathname === "/stepmint/newhome" ? "active" : ""
                      }`}
                      style={{ textDecoration: "none", color: "white" }}
                      to={`${config.baseUrl}`}
                    >
                      Home
                    </Link>
                    <Link
                      className={`scrl nav-link new-nav-link ${
                        pathname === "/stepmint/about_us" ? "active" : ""
                      }`}
                      style={{ textDecoration: "none", color: "white" }}
                      to={`${config.baseUrl}about_us`}
                    >
                      About
                    </Link>
                    <Link
                      className={`scrl nav-link new-nav-link ${
                        pathname === "/stepmint/how-it-works" ? "active" : ""
                      }`}
                      style={{ textDecoration: "none", color: "white" }}
                      to={`${config.baseUrl}how-it-works`}
                    >
                      How It Works
                    </Link>
                    {/* <Link
                      className={`scrl nav-link new-nav-link ${
                        pathname === "/stepmint/testimonial" ? "active" : ""
                      }`}
                      style={{ textDecoration: "none", color: "white" }}
                      to={`${config.baseUrl}testimonial`}
                    >
                      Testimonial
                    </Link> */}
                    <Link
                      className={`scrl nav-link new-nav-link ${
                        pathname === "/stepmint/newcontactus" ? "active" : ""
                      }`}
                      style={{ textDecoration: "none", color: "white" }}
                      to={`${config.baseUrl}newcontactus`}
                    >
                      Contact Us
                    </Link>
                  </Nav>
                  {!loginData.id ? (
                    <div className="new-nav-btn-div ">
                      {/* <Link
                        className="new-nav-buttons2"
                        to={`${config.baseUrl}signup`}
                      >
                        SignUp
                      </Link> */}
                      <Link
                        className="new-nav-buttons2"
                        to={`${config.baseUrl}login`}
                      >
                        Login
                      </Link>
                    </div>
                  ) : (
                    <>
                      {" "}
                      <Button
                        onClick={() => redirection()}
                        variant="main2"
                        className="text-white px-4 mt-3 mt-sm-0"
                        style={{ height: "40px", width: 171 }}
                      >
                        Dashboard
                      </Button>
                    </>
                  )}
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </Container>
    </>
  );
};

export default NewHeader;
